import { GenericType } from "./props";

const VesselEngineTypes: GenericType[] = [
    {key: "main engine", text: "Main engine / Mesin utama"},
    {key: "auxiliary engine", text: "Auxiliary engine / Mesin bantu"}
]

export default VesselEngineTypes;